import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  title: string;
  content: string;
  okText: string;
  cancelText: string;
  showCancel: boolean;
  model: any;
  hideButtons: boolean;
  isErrorMsg: boolean;
}

@Component({
    selector: 'popup-dialog',
    templateUrl: 'popup-dialog.component.html',
    styleUrls: ['./popup-dialog.component.scss'],
    standalone: false
})
export class PopupDialogComponent {
  errorMsgStyle = {
    'background-color': '#d2232bad',
    'color': '#fff',
    'border': '1px solid #d2232bad'
  };
  infoMsgStyle = {
    'background-color': '#0072CE',
    'color': '#fff',
    'border': '1px solid #0072CE'
  };
  constructor(
    public dialogRef: MatDialogRef<PopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
